import React from 'react';
import PropTypes from 'prop-types';

import classNames from '../../utils/classNames';

import styles from './stacked-bar.scss';

function className(isFilled) {
    return classNames(styles.segment, {
        [styles.filled]: isFilled,
    });
}

function clampSegments(segments) {
    if (segments > 60) {
        return 60;
    }

    return segments;
}

export default function StackedBar(props) {
    const { segments, filled } = props;

    const segmentDivs = [];
    let fills = filled;

    for (let i = 0; i < clampSegments(segments); i++, fills--) {
        segmentDivs.push(
            <div
                key={'segment-' + i}
                className={className(fills > 0)}
            />
        );
    }

    return (
        <div className={styles.wrapper}>
            {segmentDivs}
        </div>
    );
};

StackedBar.propTypes = {
    segments: PropTypes.number,
    filled: PropTypes.number,
};
